import { PencilIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ROUTES from '@/ROUTES'
import { format } from 'date-fns'

import { IPublicResource } from '@/MODELS/publicResource.model'

import { useResource } from '@/services/resource.service'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'
import ConfirmModal from '@/components/ConfirmModal'
import Table from '@/components/Table'

export default function AdminResourceTable() {
    const navigate = useNavigate()
    const [resources, setResources, ResourceResource] = useResource<IPublicResource[]>(ROUTES.admin.publicResource)
    const [deleteResourceId, setDeleteResourceId] = useState<string | null>(null)

    return (
        <div className='flex flex-col w-full max-w-7xl gap-5 py-10 mx-auto'>
            <AdminPageHeader
                heading={'Resource Management'}
                subheading='Add, edit, and manage all published resources'
                className='py-5'
                action={<Button onClick={() => navigate('/admin/resource/new')}> Add Resource </Button>}
            />
            <Table
                data={resources ?? []}
                columns={[
                    {
                        header: 'Title',
                        cell: (resource) => <div className='max-w-[250px] truncate'>{resource.title}</div>,
                    },

                    {
                        header: 'Category',
                        cell: 'category',
                    },
                    {
                        header: 'Tags',
                        cell: (resource) => (
                            <div className='max-w-[250px] truncate'>{resource.tags?.join(', ') || 'None'}</div>
                        ),
                    },
                    {
                        header: 'Link',
                        cell: (resource) => <div className='max-w-[150px] truncate'>{resource.link || 'None'} </div>,
                    },
                    {
                        header: 'Created At',
                        cell: (resource) => format(new Date(resource.createdAt), 'MMM d, yyyy'),
                        sort: (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
                    },

                    {
                        header: '',
                        className: 'sticky right-14 bg-white shadow-[-2px_0_4px_-2px_rgba(0,0,0,0.08)]',
                        cell: (resource) => (
                            <Link
                                to={`/admin/resource/${resource._id}`}
                                className='transition-opacity hover:opacity-70'
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <PencilIcon className='w-6 h-6 shrink-0' />
                            </Link>
                        ),
                    },
                    {
                        header: '',
                        className: 'sticky right-0 bg-white',
                        cell: (resource) => (
                            <>
                                <Button.Trash
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        console.log(resource._id)
                                        setDeleteResourceId(resource._id)
                                    }}
                                />
                            </>
                        ),
                    },
                ]}
            />

            <ConfirmModal
                open={!!deleteResourceId}
                onCancel={() => setDeleteResourceId(null)}
                onConfirm={async () => {
                    await ResourceResource.deleteById(deleteResourceId)
                    await ResourceResource.get()
                    setDeleteResourceId(null)
                }}
                title='Delete Resource'
                description='Are you sure you want to delete this resource? This action cannot be undone.'
                confirmText='Delete'
                cancelText='Cancel'
                intent='danger'
            />
        </div>
    )
}
